import script from "./PractitionerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PractitionerDetails.vue?vue&type=script&setup=true&lang=js"

import "./PractitionerDetails.vue?vue&type=style&index=0&id=594f522a&lang=css"

const __exports__ = script;

export default __exports__